import React from "react";
import "../../TrainingPages.css";

function Metadata(props) {
    /**
     * Component for the bottom left card of the splash page (additional training metadata), variable between training modules. 
     * @param props: master JSON props passed down from the SplashPage component.
     * @returns: card containing metadata entries from the splash page training module
     */
    
    return (
        <div className="col-lg-6 d-flex p-md-1">
            <div className="card dark-bg1-sport w-100">
                <div className="card-body">
                    <div className="text-left" id="extras">
                        {Object.entries(props.metadata).map(([attribute, entry]) => (
                            <div key={attribute}>
                                <b>{attribute}:</b><span className={"head-sport"}> {entry}</span><br/>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Metadata;